import tw, { classnames, display, margin, justifyContent } from 'tailwindcss-classnames';
export const containerClass = classnames(display('flex'), margin('mt-6'), justifyContent('justify-start', 'md:justify-center', 'xl:justify-start'))